module.exports = __webpack_public_path__ + "img/save.902b08bc.png";